'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Block = require('ipld-block');

var multihashing = require('multihashing-async');

var CID = require('cids');

var isIPFS = require('is-ipfs');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var blockService = _ref.blockService,
      pin = _ref.pin,
      gcLock = _ref.gcLock,
      preload = _ref.preload;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(block, options) {
      var mhtype, format, cidVersion, multihash, cid, release;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};

              if (!Array.isArray(block)) {
                _context.next = 3;
                break;
              }

              throw new Error('Array is not supported');

            case 3:
              if (Block.isBlock(block)) {
                _context.next = 16;
                break;
              }

              if (!(options.cid && isIPFS.cid(options.cid))) {
                _context.next = 8;
                break;
              }

              block = new Block(block, CID.isCID(options.cid) ? options.cid : new CID(options.cid));
              _context.next = 16;
              break;

            case 8:
              mhtype = options.mhtype || 'sha2-256';
              format = options.format || 'dag-pb';

              if (options.version == null) {
                // Pick appropriate CID version
                cidVersion = mhtype === 'sha2-256' && format === 'dag-pb' ? 0 : 1;
              } else {
                cidVersion = options.version;
              }

              _context.next = 13;
              return multihashing(block, mhtype);

            case 13:
              multihash = _context.sent;
              cid = new CID(cidVersion, format, multihash);
              block = new Block(block, cid);

            case 16:
              _context.next = 18;
              return gcLock.readLock();

            case 18:
              release = _context.sent;
              _context.prev = 19;
              _context.next = 22;
              return blockService.put(block, {
                signal: options.signal
              });

            case 22:
              if (options.preload !== false) {
                preload(block.cid);
              }

              if (!(options.pin === true)) {
                _context.next = 26;
                break;
              }

              _context.next = 26;
              return pin.add(block.cid, {
                recursive: true,
                signal: options.signal
              });

            case 26:
              return _context.abrupt("return", block);

            case 27:
              _context.prev = 27;
              release();
              return _context.finish(27);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[19,, 27, 30]]);
    }));

    function put(_x, _x2) {
      return _put.apply(this, arguments);
    }

    return put;
  }());
};